import { render } from "./EditCandidate.vue?vue&type=template&id=4700ad1c"
import script from "./EditCandidate.vue?vue&type=script&lang=js"
export * from "./EditCandidate.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3011842171/src/application/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__